import { calcPaymentAmounts } from "./paymentAmounts";

export const MAX_REGISTRATION_AMOUNT = 20_000_000;

type DraftStorage = Pick<Storage, "getItem" | "setItem">;

export function isRegistrationSessionKey(value: unknown): value is string {
  return typeof value === "string" && /^[A-Za-z0-9_-]{1,80}$/.test(value);
}

export function registrationDraftKey(sessionKey: string): string {
  if (!isRegistrationSessionKey(sessionKey)) throw new Error("올바르지 않은 결제등록 정보입니다.");
  return `julyupay:transfer:drink:${sessionKey}`;
}

export function parseRegistrationAmount(value: unknown): number | null {
  if (typeof value !== "number" && (typeof value !== "string" || !/^\d+$/.test(value))) return null;
  const amount = Number(value);
  return Number.isSafeInteger(amount) && amount > 0 && amount <= MAX_REGISTRATION_AMOUNT ? amount : null;
}

function readDraft(storage: DraftStorage, sessionKey: string): Record<string, unknown> {
  const raw = storage.getItem(registrationDraftKey(sessionKey));
  if (!raw) return {};
  try {
    const saved: unknown = JSON.parse(raw);
    return saved !== null && typeof saved === "object" && !Array.isArray(saved)
      ? saved as Record<string, unknown> : {};
  } catch {
    return {};
  }
}

export function readRegistrationAmount(storage: DraftStorage, sessionKey: string): number | null {
  return parseRegistrationAmount(readDraft(storage, sessionKey).amount);
}

export function saveRegistrationAmount(storage: DraftStorage, sessionKey: string, value: unknown): number {
  const amount = parseRegistrationAmount(value);
  if (amount === null) throw new Error("송금 금액은 1원부터 2,000만원까지 입력해 주세요.");
  // ContractTransfer owns recipient, schedule and split details. Update only this field.
  const saved = readDraft(storage, sessionKey);
  storage.setItem(registrationDraftKey(sessionKey), JSON.stringify({ ...saved, amount }));
  return amount;
}

export function estimateRegistrationAmount(value: unknown) {
  const amount = parseRegistrationAmount(value);
  if (amount === null) return { fee: 0, vat: 0, total: 0 };
  return calcPaymentAmounts(amount);
}
